// Version 1.2.2-06 2025.09.11

import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import HunyadiPage from './components/HunyadiPage';
import HegyaljaPage from './components/HegyaljaPage';
import VendegLap1 from './components/VendegLap1';
import VendegLap2 from './components/VendegLap2';

// Bejelentkezési komponens
const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [accessCode, setAccessCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = username.trim();
    const pass = password; // jelszót nem trimmeljük
    const code = String(accessCode || '').trim();

    if (user === 'AdmiN' && pass === 'AquaSanitas') {
      if (code === '3645') {
        localStorage.setItem('authData', JSON.stringify({ username: user, password: pass, accessCode: code }));
        onLogin('home');
      } else if (code === '1645') {
        localStorage.setItem('authData', JSON.stringify({ username: user, password: pass, accessCode: code }));
        onLogin('guest');
      } else if (code === '7645') {
        localStorage.setItem('authData', JSON.stringify({ username: user, password: pass, accessCode: code }));
        onLogin('guest2');
      } else {
        alert('Hibás kód');
      }
    } else {
      alert('Hibás bejelentkezési adatok');
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem('authData');
    if (!saved) return;
    const { username: u, password: p, accessCode: c } = JSON.parse(saved);
    const code = String(c || '').trim();
    if (u === 'AdmiN' && p === 'AquaSanitas') {
      if (code === '3645') onLogin('home');
      else if (code === '1645') onLogin('guest');
      else if (code === '7645') onLogin('guest2');
    }
  }, [onLogin]);

  return (
    <form onSubmit={handleSubmit} className="loginForm">
      <label>
        Felhasználónév:
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
      </label>
      <br />
      <label>
        Jelszó:
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>
      <br />
      <label>
        Kód:
        <input type="text" value={accessCode} onChange={(e) => setAccessCode(e.target.value)} />
      </label>
      <br />
      <button type="submit">Bejelentkezés</button>
    </form>
  );
};

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const savedAuthData = localStorage.getItem('authData');
    if (!savedAuthData) return;
    const { username, password, accessCode } = JSON.parse(savedAuthData);
    const code = String(accessCode || '').trim();
    if (username === 'AdmiN' && password === 'AquaSanitas') {
      if (code === '3645') { setUserRole('home'); setLoggedIn(true); }
      else if (code === '1645') { setUserRole('guest'); setLoggedIn(true); }
      else if (code === '7645') { setUserRole('guest2'); setLoggedIn(true); }
    }
  }, []);

  if (!loggedIn) {
    return <Login onLogin={(role) => { setUserRole(role); setLoggedIn(true); }} />;
  }

  return (
    <Router>
      <Routes>
        {userRole === 'home' ? (
          <Route path="/" element={<HomePage />} />
        ) : userRole === 'guest2' ? (
          <Route path="/" element={<VendegLap2 />} />
        ) : (
          <Route path="/" element={<VendegLap1 />} />
        )}
        <Route path="/hunyadi" element={<HunyadiPage apiKey="API-001" />} />
        <Route path="/hegyalja" element={<HegyaljaPage apiKey="API-002" />} />
      </Routes>

      {/* Diszkrét manuális frissítés ikon */}
      <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 9999, opacity: 0.6 }}>
        <button
          onClick={() => window.location.reload(true)}
          style={{
            width: '36px', height: '36px', borderRadius: '50%',
            backgroundColor: '#444', color: '#fff', fontSize: '20px',
            lineHeight: '0', border: 'none', cursor: 'pointer'
          }}
          title="Frissítés"
        >
          ↻
        </button>
      </div>
    </Router>
  );
};

export default App;


/*
Módosítások:
Felhasználónév: admin helyett AdmiN
Jelszó: secret helyett AquaSanitas
Access kódok:
1234 helyett 3645 (home)
1235 helyett 1645 (guest)
*/

